import { PickingSetError } from './PickingSetError';

export class InvalidStateError extends PickingSetError {}
